const UPDATE_MUTATION = `
  mutation UpdateCard($uuid: String!, $username: String!, $isBypass: Boolean) {
    updateCard(params: {
      uuid: $uuid,
      username: $username,
      isBypass: $isBypass
    }) {
      uuid
      isBypass
    }
  }
`

const DELETE_MUTATION = `
  mutation deleteCard ($uuid: String!) {
    deleteCard (uuid: $uuid)
  }
`

const LIST_QUERY = `
  query listCards ($username: String!) {
    listCards (username: $username) {
      acmId
      uuid
      createdAt
      lastUsedAt
    }
  }
`
const LIST_UNASSIGNED_QUERY = `
  query listUnassignedCards($fromDate: DateTime!, $toDate: DateTime!) {
    listUnassignedCards(fromDate: $fromDate, toDate: $toDate) {\
      acmId
      priority
      isBypass
      isActive
      cardFormat
      uuid
      createdAt
      lastUsedAt
      lastUsedDeviceName
    }
  }
`

const cardQueries = {
  methods: {
    async updateCardMutation(cardDetails) {
      try {
        const result = await this.graphQuery(UPDATE_MUTATION, cardDetails)
        return result.updateCard
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteCardMutation(uuid) {
      try {
        await this.graphQuery(DELETE_MUTATION, uuid)
      } catch (error) {
        throw new Error(error)
      }
    },
    async listCardsQuery(username) {
      try {
        const result = await this.graphQuery(LIST_QUERY, username)
        return result.listCards
      } catch (error) {
        throw new Error(error)
      }
    },
    async listUnassignedCardsQuery(fromDate, toDate) {
      try {
        const result = await this.graphQuery(LIST_UNASSIGNED_QUERY, {fromDate, toDate})
        return result.listUnassignedCards
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default cardQueries
